// Module
var code = "<div fg-property-field-common=\"{ fieldname: true, displayname: true, tooltip: false }\"></div> <div fg-property-field=\"fieldValue\"> <button type=\"submit\" name=\"fieldValue\" ng-model=\"field.value\" class=\"waves-effect waves-light btn\"> {{ field.schema.displayName }} <i class=\"fa-light fa-paper-plane\"></i> </button> </div> ";
// Exports
export default code;